import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06c70246"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { style: {"display":"inline-flex","margin-bottom":"10px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  style: {"color":"#67C23A"}
}
const _hoisted_5 = {
  key: 1,
  style: {"color":"#F56C6C"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }

import { type Pagination, type DataDownLoadListItem, type FormState } from './types'
import { type UnwrapRef, onMounted, reactive, ref } from 'vue'
import { dataDownload, deleteDataDownLoadList, getApprovalStatusOption, getDataDownLoadList } from './service'
import BaseTable from './components/base-table/index.vue'
import SelectOptimizer from './components/select-optimizer/index.vue'
import { Modal, type TableColumnsType, message } from 'ant-design-vue'
import dayjs from 'dayjs'
import { DATA_STATUS, DATA_STATUS_MAPPING, CONTENT } from './constants'
import { saveAs } from 'file-saver'
import LogDialog from './components/log-dialog.vue'
import { Card, Form, FormItem, Input, Button, Tooltip, ConfigProvider, Popover } from 'ant-design-vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { QuestionCircleOutlined } from '@ant-design/icons-vue'

interface Props{
  btnAuthGroup:string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index.ce',
  props: {
    btnAuthGroup: {}
  },
  setup(__props: any) {

const props = __props
const btnAuth = JSON.parse(props.btnAuthGroup)
const permissionLevel = ref<number>(0)
const isLoading = ref<boolean>(false)
const tableData = ref<DataDownLoadListItem[]>()
const pagination = reactive<Pagination>({
  pageSize: 20,
  page: 1,
  total: 0,
})
const logState = reactive({
  id: 20,
  visible: false,
})
const formState: UnwrapRef<FormState> = reactive({
  name: '',
  createUser: null,
})
const bigBox = ref<HTMLDivElement>();
const approvalStatusMap = ref<Record<string, string>>({})
const approvalStatusWords = {
  PENDING: 'PENDING', // 审批中
  APPROVED: 'APPROVED', // 审批通过
  CANCELED: 'CANCELED', // 已撤回
  REJECTED: 'REJECTED', // 审批拒绝
}

getApprovalStatusOption().then(res => {
  res.forEach(item => {
    approvalStatusMap.value[item.value] = item.text
  })
})

const showLogDialog = (item: DataDownLoadListItem) => {
  Object.assign(logState, {
    id: item.id,
    visible: true,
  })
}

const downloadItem = (item: DataDownLoadListItem) => {
  dataDownload(item.id, item.ossUrl)
    .then(res => {
      saveAs(res.fileUrl)
    })
}

const deleteItem = (id: number) => {
  Modal.confirm({
    title: '确认',
    content: '确定删除吗？',
    okText: '确定',
    cancelText: '取消',
    closable: true,
    onOk: () => {
      deleteDataDownLoadList(id)
        .then(() => {
          getList()
          message.success('删除成功')
        })
    },
  })
}

const getList = async () => {
  isLoading.value = true

  return getDataDownLoadList({
    pageNum: pagination.page,
    pageSize: pagination.pageSize,
    queryCreateUser: formState.createUser,
    queryName: formState.name,
  })
    .then((res) => {
      pagination.total = +res.page.total
      permissionLevel.value = res.permissionLevel

      const list = res.page.list || []

      list.forEach(item => {
        item.createTimeStr = dayjs(+item.createTime * 1000).format('YYYY-MM-DD HH:mm:ss')
      })
      tableData.value = list
    })
    .finally(() => {
      isLoading.value = false
    })
}

const onChangePage = (page: number) => {
  pagination.page = page
  getList()
}

const onSearch = () => {
  pagination.page = 1
  getList()
}

onMounted(() => {
  getList()

  document.querySelectorAll("style").forEach((item) => {
    bigBox.value?.appendChild(item.cloneNode(true));
  })
})

const columns = ref<TableColumnsType>([
  {
    title: '文件名称',
    dataIndex: 'name',
    resizable: true,
    width: 150,
  },
  {
    title: '数据量',
    dataIndex: 'fileNum',
    resizable: true,
    width: 100,
  },
  {
    title: '文件类型',
    dataIndex: 'dataType',
    resizable: true,
    width: 100,
  },
  {
    title: '文件大小',
    dataIndex: 'fileSizeStr',
    resizable: true,
    width: 100,
  },
  {
    title: '创建者',
    dataIndex: 'createUser',
    resizable: true,
    width: 100,
  },
  {
    title: '创建时间',
    dataIndex: 'createTimeStr',
    resizable: true,
    width: 100,
  },
  {
    title: '文件生成状态',
    dataIndex: 'status',
    resizable: true,
    width: 100,
  },
  {
    title: '流程审批状态',
    dataIndex: 'approvalStatus',
    resizable: true,
    width: 100,
  },
  {
    title: '高级操作',
    dataIndex: 'action',
    resizable: true,
    width: 140,
  },
])

return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_unref(ConfigProvider), { locale: _unref(zhCN) }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "big-box",
        ref_key: "bigBox",
        ref: bigBox
      }, [
        _createVNode(_unref(Card), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Popover), { placement: "rightTop" }, {
              content: _withCtx(() => [
                _createElementVNode("div", {
                  style: {"font-size":"13px","width":"700px"},
                  innerHTML: _unref(CONTENT)
                }, null, 8, _hoisted_1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, [
                  _createTextVNode("如何使用数据下载服务"),
                  _createVNode(_unref(QuestionCircleOutlined), { style: {"margin-left":"3px"} })
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Form), {
              "label-align": "right",
              layout: "inline",
              model: formState
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormItem), { label: "文件名称" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Input), {
                      value: formState.name,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.name) = $event)),
                      "allow-clear": "",
                      placeholder: "请输入"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormItem), {
                  colon: false,
                  label: "创建人"
                }, {
                  default: _withCtx(() => [
                    _createVNode(SelectOptimizer, {
                      value: formState.createUser,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.createUser) = $event)),
                      "is-multiple": false
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  type: "primary",
                  onClick: onSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 查询 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_card, { style: {"margin-top":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(BaseTable, {
              columns: columns.value,
              "is-loading": isLoading.value,
              pagination: pagination,
              "table-data": tableData.value,
              onChangePage: onChangePage
            }, {
              bodyCell: _withCtx(({ column, record }) => [
                (column.dataIndex === 'name')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(record.name), 1))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'dataType')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (record.dataType === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "一般数据"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_5, "敏感数据"))
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'status')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (record.status !== _unref(DATA_STATUS).FAILURE)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(DATA_STATUS_MAPPING)[record.status]), 1))
                        : (_openBlock(), _createBlock(_unref(Tooltip), { key: 1 }, {
                            title: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(record.remark), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_unref(DATA_STATUS_MAPPING)[record.status]), 1)
                            ]),
                            _: 2
                          }, 1024))
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'approvalStatus')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      (record.status === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                            (!record.approval)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " 无审批 "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(approvalStatusMap.value[record.approvalStatus]), 1))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_10, "/"))
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      (record.status === 1 && (record.approvalStatus === approvalStatusWords.APPROVED || !record.approval) && _unref(btnAuth).downLoad)
                        ? (_openBlock(), _createBlock(_unref(Button), {
                            key: 0,
                            class: "clear-padding",
                            disabled: record.status !== _unref(DATA_STATUS).DOWNLOAD,
                            type: "link",
                            onClick: ($event: any) => (downloadItem(record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 下载 ")
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]))
                        : _createCommentVNode("", true),
                      (record.status === 1 && (record.approvalStatus === approvalStatusWords.APPROVED || !record.approval) && _unref(btnAuth).log)
                        ? (_openBlock(), _createBlock(_unref(Button), {
                            key: 1,
                            class: "clear-padding",
                            disabled: record.status !== _unref(DATA_STATUS).DOWNLOAD,
                            type: "link",
                            onClick: ($event: any) => (showLogDialog(record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 日志 ")
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]))
                        : _createCommentVNode("", true),
                      (record.approvalStatus !== approvalStatusWords.PENDING && _unref(btnAuth).delete)
                        ? (_openBlock(), _createBlock(_unref(Button), {
                            key: 2,
                            class: "clear-padding",
                            danger: "",
                            type: "link",
                            onClick: ($event: any) => (deleteItem(record.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 删除 ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "is-loading", "pagination", "table-data"])
          ]),
          _: 1
        }),
        (logState.visible)
          ? (_openBlock(), _createBlock(LogDialog, {
              key: 0,
              id: logState.id,
              visible: logState.visible,
              "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((logState.visible) = $event))
            }, null, 8, ["id", "visible"]))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})